import { createClient } from '@/shared/api';
import REVIEW_HOLTER_EVENTS_MUTATION from '@/entities/event/api/mutations/reviewHolterEvents';
import type {
  ReviewHolterEventsMutation,
  ReviewHolterEventsMutationVariables,
} from '@/shared/api/generated/graphql';

export type ReviewHolterEventsResult = {
  isSuccess: boolean;
  message: string;
  messageId: string;
  command: string;
};

// TODO(ts): typed as the ReviewHolterEventsInputV2 GraphQL input once its server-side shape is documented
/**
 * Marks holter events as reviewed or unreviewed on the server. Runs the reviewHolterEventsV2 mutation and throws the server message, or a generic fallback, when isSuccess is not set.
 *
 * @param input - Mutation input carrying the review changes.
 * @returns A promise resolving to the reviewHolterEventsV2 result.
 */
const handleReviewHolterEvents = async (input: any) => {
  const client = await createClient();
  const result = await client.mutate<
    ReviewHolterEventsMutation,
    ReviewHolterEventsMutationVariables
  >({
    mutation: REVIEW_HOLTER_EVENTS_MUTATION,
    variables: {
      input,
    },
  });
  const { data } = result || {};
  const { reviewHolterEventsV2 } = data || {};
  if (!reviewHolterEventsV2?.isSuccess) {
    throw new Error(reviewHolterEventsV2?.message || 'Failed to review holter events');
  }
  return reviewHolterEventsV2;
};

export default handleReviewHolterEvents;
